module.exports = __webpack_public_path__ + "static/bundle-team-b418eb888c754686f331866dfe294803.png";